import { render, staticRenderFns } from "./ToBeConfiguredHotel.vue?vue&type=template&id=32450fa4&scoped=true"
import script from "./ToBeConfiguredHotel.vue?vue&type=script&lang=js"
export * from "./ToBeConfiguredHotel.vue?vue&type=script&lang=js"
import style0 from "./ToBeConfiguredHotel.vue?vue&type=style&index=0&id=32450fa4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32450fa4",
  null
  
)

export default component.exports